import React, { CSSProperties } from 'react';

import useStyles from './Hero.style';

interface HeroProps {
  children?: React.ReactNode;
  className?: string;
  style?: CSSProperties;
  contentStyle?: CSSProperties;
  contentClass?: string;
  overlay?: boolean;
  overlayStyle?: 'fadeup' | 'cover';
  backgroundColor?: string;
  backgroundImage?: string;
  linearGradient?: string;
}

const Hero: React.FC<HeroProps> = (props) => {
  const { 
    children, 
    className, 
    style,
    contentStyle,
    contentClass,
    backgroundColor, 
    backgroundImage, 
    overlay,
    overlayStyle,
    linearGradient
  } = props;

  const { classes, cx } = useStyles();

  const styleObj = { ...style };

  const bgProps = {};

  if (backgroundColor) {
    styleObj.backgroundColor = backgroundColor;
  }
  
  if (backgroundImage && overlay && overlayStyle) {
    if (overlayStyle === 'cover') {
      bgProps['data-bg-multi'] = `linear-gradient(rgba(8, 8, 8, .35) 100%, rgba(8, 8, 8, .35) 100%), url(${backgroundImage})`;
    }

    if (overlayStyle === 'fadeup') {
      bgProps['data-bg-multi'] = `linear-gradient(to bottom, rgba(18, 18, 18, 0) 33%, #080808), url(${backgroundImage})`;
    }
  } else if (backgroundImage && linearGradient) {
    bgProps['data-bg-multi'] = `${linearGradient}, url(${backgroundImage})`;
  } else if (backgroundImage) {
    bgProps['data-bg'] = backgroundImage;
  }

  return (
    <div
      className={cx(classes.heroWrapper, className)}
      style={styleObj}
      {...bgProps}
    >
      <div
        className={cx(classes.heroContent, contentClass)}
        style={contentStyle}
      >
        {children}
      </div>
    </div>
  );
};

Hero.defaultProps = {
  style: {},
  contentStyle: {},
  backgroundColor: '',
  backgroundImage: '',
  overlay: false,
  overlayStyle: 'fadeup',
};

export default Hero;
